import React, { Component } from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class ChannelNameFilter extends Component {
    state = {
        channelLists: [ ],
        channelValue: '',
    };

    componentDidMount() {
        this._getChannel(this.props.start_date, this.props.end_date);
    }

    resetChannelFilter() {
        this.setState({
            channelValue: [],
        });
    }

    _getChannel(start_date, end_date) {
        axios.post(config.get('API_URL') + '/filters/service_reports/get-channel/', {
            yestSend: start_date,
            todSend: end_date,
        },
        {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            this.setState({
                channelLists: []
            });
            if (Array.isArray(response.data) && response.data.length) {
                response.data.map((item) => {
                    this.state.channelLists.push({ value: item.channelname, label: item.channelname }); // Keep "item.tenure" if backend sends that key
                });
            }
        });
    }

    changeChannel(optionSelected) {
        let value = '';
        let channelArray = [];

        if (optionSelected.length < 1) {
            value = null;
            channelArray = '';
        } else {
            optionSelected.map((item) => {
                channelArray.push(item.value);
            });
        }

        this.props.onSelectChannel(optionSelected, channelArray);

        this.setState({
            channelValue: optionSelected,
        });
    }

    render() {
        return (
            <ReactMultiSelectCheckboxes
                name="channel"
                isMulti
                value={this.state.channelValue}
                styles={reactSelectStyles}
                className="report-listbox"
                isClearable={false}
                onChange={this.changeChannel.bind(this)}
                options={this.state.channelLists}
                placeholderButtonLabel="Select [Channel]"
            />
        );
    }
}

export default ChannelNameFilter;
